// export const nodeExpressBeagleHash = 'MMPi426Qm3bj1y7bG3j2Yg0G91j34';
//export const awsTableOfContentsURL = 'http://localhost:5000/nrc/toc/v1';
// export const awsCropCalculatorURL = 'http://localhost:5000/nrc/calc/v1';
// export const awsTableOfContentsURL = 'https://app.plantnutrition.io/nrc/toc/v1';
// export const awsCropCalculatorURL = 'https://app.plantnutrition.io/nrc/calc/v1';

export const nodeExpressBeagleHash = 'WBWLPiTmQELMAm63NXdi92gWFyQfjZu6bwmQMLZe';
//export const awsTableOfContentsURL = 'http://localhost:5000/nrc/toc/v1';
// export const awsCropCalculatorURL = 'http://localhost:5000/nrc/calc/v1';
export const awsTableOfContentsURL = 'https://api.plantnutrition.io/nurd/toc';
export const awsCropCalculatorURL = 'https://api.plantnutrition.io/nurd/calculator';
